// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__1fZyv","detailsBorder":"styles_detailsBorder__32BJp"};